<template>
    <div class="select_product publish">
        <section class="breadcrumb-section pb-0">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item">
                            <a href="#">Team Store</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Custom Store
                        </li>
                    </ol>
                </nav>
            </div>
        </section>
        <section class="checkout_wizard pb-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div
                            class="wizard d-flex justify-content-center align-items-center"
                        >
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle done mr_10">
                                    <img
                                        src="/maincss/images/wizard_checked.svg"
                                        alt=""
                                    />
                                </div>
                                <h5 class="mb-0">Basic Information</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle done mr_10">
                                    <img
                                        src="/maincss/images/wizard_checked.svg"
                                        alt=""
                                    />
                                </div>
                                <h5 class="mb-0">Select Product</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle done mr_10">
                                    <img
                                        src="/maincss/images/wizard_checked.svg"
                                        alt=""
                                    />
                                </div>
                                <h5 class="mb-0">Design</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle done mr_10">
                                    <img
                                        src="/maincss/images/wizard_checked.svg"
                                        alt=""
                                    />
                                </div>
                                <h5 class="mb-0">Shipping</h5>
                            </div>
                            <div class="devider"></div>
                            <div
                                class="field d-flex justify-content-center align-items-center"
                            >
                                <div class="circle mr_10">5</div>
                                <h5 class="mb-0">Publish</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="publish">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="heading1 mb_6">Publish</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="grey_border_box mt_20">
                            <div class="row">
                                <div class="col-md-6 accordian_with_form">
                                    <div
                                        class="accordion left_box_cutom_width"
                                        id="accordionExample"
                                    >
                                        <div class="card">
                                            <div
                                                class="card-header p-0"
                                                id="headingOne"
                                            >
                                                <h2
                                                    class="mb-0 accordian_heading text-left d-flex"
                                                    data-toggle="collapse"
                                                    data-target="#collapseOne"
                                                    aria-expanded="true"
                                                    aria-controls="collapseOne"
                                                >
                                                    Send Invite
                                                    <span
                                                        class="ml-auto my-auto minus"
                                                        ><img
                                                            src="/maincss/images/minus.svg"
                                                            alt=" "
                                                    /></span>
                                                    <span
                                                        class="ml-auto my-auto plus"
                                                        ><img
                                                            src="/maincss/images/plus.svg"
                                                            alt=" "
                                                    /></span>
                                                </h2>
                                            </div>
                                            <div
                                                id="collapseOne"
                                                class="collapse show"
                                                aria-labelledby="headingOne"
                                                data-parent="#accordionExample"
                                            >
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <p
                                                                class="m-0 d-inline-block publish_radio_btn"
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    id="test1"
                                                                    name="radio-group"
                                                                    checked="checked"
                                                                />
                                                                <label
                                                                    for="test1"
                                                                    class="m-0 opacity_60 send_label_pad"
                                                                    >Enter Email
                                                                    ID
                                                                </label>
                                                            </p>
                                                            <p
                                                                class="m-0 d-inline-block pl_42 up-cv-publish publish_radio_btn"
                                                            >
                                                                <input
                                                                    type="radio"
                                                                    id="test2"
                                                                    name="radio-group"
                                                                />
                                                                <label
                                                                    for="test2"
                                                                    class="m-0 opacity_60 upload-cv send_label_pad"
                                                                    >Upload
                                                                    CSV</label
                                                                >
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div
                                                                class="d-flex mt_30 team-publish"
                                                            >
                                                                <label
                                                                    class="font_size_18 pr_28 email-send-team"
                                                                    >Email
                                                                    Id</label
                                                                >
                                                                <div
                                                                    class="vue_tag"
                                                                >
                                                                    <VueTagsInput
                                                                        v-model="
                                                                            tag
                                                                        "
                                                                        :tags="[
                                                                            'emma.waugh@gmail.com',
                                                                            'emma.waugh@gmail.com',
                                                                            'emma.waugh@gmail.com'
                                                                        ]"
                                                                        @tags-changed="
                                                                            (
                                                                                newTags
                                                                            ) =>
                                                                                (tags =
                                                                                    newTags)
                                                                        "
                                                                    />
                                                                    <p
                                                                        class="mt_10 mb-0"
                                                                        style="
                                                                            color: #727272;
                                                                        "
                                                                    >
                                                                        Add
                                                                        multiple
                                                                        Email
                                                                        ID’s
                                                                        seperated
                                                                        by comma
                                                                    </p>
                                                                    <div
                                                                        class="form-group p-0 mx-0"
                                                                    >
                                                                        <textarea
                                                                            class="form-control bg-transparent mt_58"
                                                                            placeholder="Enter Your Message (Optional)"
                                                                        ></textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- upload row start -->
                                                    <div
                                                        class="row mt_20 publish_upload_row"
                                                    >
                                                        <div class="col-md-12">
                                                            <div
                                                                class="publish_upload_box"
                                                            >
                                                                <form action="">
                                                                    <div
                                                                        class="input_text_img_box"
                                                                    >
                                                                        <img
                                                                            src="/maincss/images/upload_icon.svg"
                                                                            alt="img"
                                                                        />
                                                                        <label
                                                                            for="formFile"
                                                                            class="form-label"
                                                                            >Your
                                                                            Csv
                                                                            File
                                                                            Here
                                                                            Or
                                                                            <span
                                                                                >Browse</span
                                                                            >
                                                                            Your
                                                                            Computer
                                                                        </label>
                                                                    </div>
                                                                    <input
                                                                        class="form-control"
                                                                        type="file"
                                                                    />
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- upload row end -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card mt_30">
                                            <div
                                                class="card-header p-0"
                                                id="headingTwo"
                                            >
                                                <h2
                                                    class="mb-0 accordian_heading text-left d-flex"
                                                    data-toggle="collapse"
                                                    data-target="#collapseTwo"
                                                    aria-expanded="true"
                                                    aria-controls="collapseTwo"
                                                >
                                                    Add Additional Admin
                                                    (Optional)
                                                    <span
                                                        class="ml-auto my-auto minus"
                                                        ><img
                                                            src="/maincss/images/minus.svg"
                                                            alt=" "
                                                    /></span>
                                                    <span
                                                        class="ml-auto my-auto plus"
                                                        ><img
                                                            src="/maincss/images/plus.svg"
                                                            alt=" "
                                                    /></span>
                                                </h2>
                                            </div>
                                            <div
                                                id="collapseTwo"
                                                class="collapse show"
                                                aria-labelledby="headingTwo"
                                                data-parent="#accordionExample"
                                            >
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div
                                                                class="d-flex team-publish"
                                                            >
                                                                <label
                                                                    style="
                                                                        color: #000;
                                                                    "
                                                                    class="font_size_18 email-send-team"
                                                                    >Email
                                                                    Id</label
                                                                >
                                                                <div
                                                                    class="vue_tag"
                                                                >
                                                                    <VueTagsInput
                                                                        v-model="
                                                                            tag
                                                                        "
                                                                        :tags="[
                                                                            'austin.agare@gmail.com'
                                                                        ]"
                                                                        @tags-changed="
                                                                            (
                                                                                newTags
                                                                            ) =>
                                                                                (tags =
                                                                                    newTags)
                                                                        "
                                                                    />
                                                                    <p
                                                                        class="mt_10 mb-0"
                                                                        style="
                                                                            color: #727272;
                                                                        "
                                                                    >
                                                                        Add
                                                                        multiple
                                                                        Email
                                                                        ID’s
                                                                        seperated
                                                                        by comma
                                                                    </p>

                                                                    <!-- <div class="form-group p-0 mx-0">
														  <textarea class="form-control bg-transparent mt_40" placeholder="Enter Your Message (Optional)" ></textarea>
														</div> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="card mt_30 publish_copy_link_card"
                                        >
                                            <div class="card-header p-0">
                                                <h2
                                                    class="mb-0 accordian_heading text-left d-flex"
                                                >
                                                    Prefer to send via your
                                                    personal email account? Copy
                                                    and paste this link
                                                </h2>
                                            </div>
                                            <div>
                                                <div class="card-body">
                                                    <div
                                                        class="input-group copy_link"
                                                    >
                                                        <div
                                                            class="input-group-prepend"
                                                        >
                                                            <span
                                                                class="input-group-text"
                                                                id="basic-addon1"
                                                                ><img
                                                                    src="/maincss/images/link.svg"
                                                                    alt=" "
                                                            /></span>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            class="form-control"
                                                            disabled
                                                            placeholder="https://imprintcity.com/stregis"
                                                            value="https://imprintcity.com/stregis"
                                                            aria-label="Username"
                                                            aria-describedby="basic-addon1"
                                                        />
                                                        <div
                                                            class="input-group-prepend"
                                                        >
                                                            <a
                                                                href="#"
                                                                class="btn btn_outline_primary border_primary_blue text_primary_blue pt_14 tooltip"
                                                                >Copy
                                                                <span
                                                                    class="tooltiptext"
                                                                    >Copy to
                                                                    clipboard</span
                                                                >
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <h2
                                        class="font_size_18 text_primary_blue d-md-flex mb_0 right_box_cutom_width"
                                    >
                                        Design Preview ( 1 - 7 )
                                        <a href="#" class="ml-auto"
                                            ><img
                                                src="/maincss/images/edit.svg"
                                                alt=" "
                                        /></a>
                                    </h2>
                                    <div
                                        class="product_details pt_20 right_box_cutom_width"
                                    >
                                        <div
                                            class="swiper-container gallery-main"
                                        >
                                            <div class="slider_border">
                                                <div class="swiper-wrapper">
                                                    <div class="swiper-slide">
                                                        <img
                                                            src="/maincss/images/pr1.png"
                                                            alt="Slide 01"
                                                        />
                                                    </div>
                                                    <div class="swiper-slide">
                                                        <img
                                                            src="/maincss/images/product_image_2.png"
                                                            alt="Slide 02"
                                                        />
                                                    </div>
                                                    <div class="swiper-slide">
                                                        <img
                                                            src="/maincss/images/product_image_3.png"
                                                            alt="Slide 03"
                                                        />
                                                    </div>
                                                    <div class="swiper-slide">
                                                        <img
                                                            src="/maincss/images/product_image_4.png"
                                                            alt="Slide 04"
                                                        />
                                                    </div>
                                                    <div class="swiper-slide">
                                                        <img
                                                            src="/maincss/images/product_image_5.png"
                                                            alt="Slide 05"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mobile_arrow_publish">
                                                <div
                                                    class="swiper-button-prev"
                                                ></div>
                                                <div
                                                    class="swiper-button-next"
                                                ></div>
                                            </div>
                                            <div class="favriout">
                                                <a href="#"
                                                    ><img
                                                        src="/maincss/images/favriout_produt.png"
                                                        alt=" "
                                                /></a>
                                            </div>
                                        </div>

                                        <div
                                            class="swiper-container gallery-thumbs"
                                        >
                                            <div class="custome_arrow_position">
                                                <div
                                                    class="swiper-button-prev"
                                                ></div>
                                                <div
                                                    class="swiper-button-next"
                                                ></div>
                                            </div>

                                            <div class="swiper-wrapper">
                                                <div class="swiper-slide">
                                                    <img
                                                        src="/maincss/images/thumbnail_1.png"
                                                        alt="Slide 01"
                                                    />
                                                </div>
                                                <div class="swiper-slide">
                                                    <img
                                                        src="/maincss/images/thumbnail_2.png"
                                                        alt="Slide 02"
                                                    />
                                                </div>
                                                <div class="swiper-slide">
                                                    <img
                                                        src="/maincss/images/thumbnail_3.png"
                                                        alt="Slide 03"
                                                    />
                                                </div>
                                                <div class="swiper-slide">
                                                    <img
                                                        src="/maincss/images/thumbnail_4.png"
                                                        alt="Slide 04"
                                                    />
                                                </div>
                                                <div class="swiper-slide">
                                                    <img
                                                        src="/maincss/images/thumbnail_5.png"
                                                        alt="Slide 04"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="buttons mt_40 ml-auto text-right">
                            <a
                                href="/team/shipping"
                                class="btn btn_outline_primary border_primary_blue text_primary_blue py_18 px_52 mr_34"
                                >BACK</a
                            >
                            <a
                                href="/team/created-team-store"
                                class="btn btn_orange bg_primary_orange text_white py_18 px_52"
                                >Publish</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    /* eslint-disable */
    name: "Publish",
    /* eslint-enable */
    data() {
        return {
            tag: "",
            tags: []
        };
    },
    components: {},
    mounted() {
        document.body.classList.add("");
        /* eslint-disable */
        var galleryThumbs = new Swiper(".gallery-thumbs", {
            centeredSlides: true,
            centeredSlidesBounds: true,
            slidesPerView: 5,
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            direction: "horizontal",
            breakpoints: {
                0: {
                    slidesPerView: 3.5,
                    spaceBetween: 10,
                    direction: "horizontal"
                },
                768: {
                    slidesPerView: 5,
                    spaceBetween: 50,
                    direction: "horizontal"
                },
                991: {
                    slidesPerView: 5,
                    spaceBetween: 50,
                    direction: "horizontal"
                }
            }
        });
        var galleryMain = new Swiper(".slider_border", {
            watchOverflow: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            preventInteractionOnTransition: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            // effect: 'fade',
            //   fadeEffect: {
            //   crossFade: true
            // },
            thumbs: {
                swiper: galleryThumbs
            }
        });
        /* eslint-enable */
        galleryMain.on("slideChangeTransitionStart", function () {
            galleryThumbs.slideTo(galleryMain.activeIndex);
        });
        galleryThumbs.on("transitionStart", function () {
            galleryMain.slideTo(galleryThumbs.activeIndex);
        });
    },
    computed: {
        // ...mapGetters(["isAuthenticated", "tags"]),
        // tag() {
        //   return this.$route.params.tag;
        // }
    }
};
</script>
